import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DialogResult, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'app-iccms-request-processing-schedule-list',
  templateUrl: './iccms-request-processing-schedule-list.component.html',
  styleUrl: './iccms-request-processing-schedule-list.component.scss'
})
export class IccmsRequestProcessingScheduleListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private errorService: ErrorService,) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.iccmsRequestProcessingScheduleList,
      () => API_ENDPOINTS.dashboard.getIccmsRequestProcessingSchedules,
      false);
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad($event: any) {
    this.loadGridDataOnFormLoad();
  }

  actionButton_scheduleGrid_datagrid_new_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.prefix]);
  }

  actionButton_scheduleGrid_datagrid_schedule_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.prefix, event.event.data.id]);
  }

  actionButton_scheduleGrid_datagrid_delete_Clicked(event: any) {
    this.activeDialog = POP_UP_CODES.iccmsRequestProcessingScheduleList.confirmDelete;
    this.dialogService.showConfirm(this.activeDialog)
      .pipe(take(1))
      .subscribe(data => {
        data = data as DialogResult;
        if (data === DialogResult.ACCEPTED) {
          this.spinnerService.showSpinner();
          this.deleteSchedule(event.event.data.id);
        }
      });
  }

  private deleteSchedule(id: string) {
    const endpoint = `${API_ENDPOINTS.iccmsRequestProcessingSchedule.delete}/${id}`;
    this.registerSubscription(
      this.appDataService.post(endpoint, null)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.deleteIccmsRequestProcessingSchedule.includes(data.message)) {
              this.activeDialog = data.message;
              this.dialogService.showDialog(this.activeDialog);
            }
            else {
              this.reloadPage();
            }
          }
        })
    );
  }
}
